import { useState } from "react";
import { C } from "./constants/colors";
import { Layout } from "./components/ui";
import { useAuth } from "./hooks/useAuth";
import { useWasteData } from "./hooks/useWasteData";
import { useWasteAccounts } from "./hooks/useWasteAccounts";
import { useOrgProfile } from "./hooks/useOrgProfile";
import Login from "./screens/Login";
import Onboarding from "./screens/Onboarding";
import Dashboard from "./screens/Dashboard";
import WasteDataHub from "./screens/WasteDataHub";
import WasteAccounts from "./screens/WasteAccounts";
import AuditFlow from "./screens/AuditFlow";

const AUDIT_FLOW_SCREENS=["baseline","data-config","audit-prep","audit","location-detail","results","plan"];

// ══════════════════════════════════════════════════════════════
export default function App(){
  const [screen,setScreen]=useState("onboarding");
  const [dataConfigOrigin,setDataConfigOrigin]=useState("baseline"); // where "← Back"/"Continue" on data-config return to

  const authApi=useAuth();
  const waste=useWasteData();
  const accounts=useWasteAccounts();
  const orgProfile=useOrgProfile({
    user:authApi.user, setScreen,
    wasteData:waste.wasteData, setWasteData:waste.setWasteData,
    wasteDataConfig:waste.wasteDataConfig, setWasteDataConfig:waste.setWasteDataConfig,
    wasteAccounts:accounts.wasteAccounts, setWasteAccounts:accounts.setWasteAccounts,
  });

  if(authApi.user===undefined||orgProfile.appLoading)return(
    <div style={{minHeight:"100vh",background:C.sand,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{color:C.muted,fontSize:14}}>Loading…</div>
    </div>
  );

  if(authApi.user===null) return <Login auth={authApi}/>;

  // ── Org onboarding (first login) ───────────────────────────
  if(screen==="org-onboarding") return <Onboarding orgProfile={orgProfile}/>;

  const navigate=s=>{
    if(s==="location-detail"&&!orgProfile.activeLocationId&&orgProfile.locationAudits.length>0){
      orgProfile.setActiveLocationId(orgProfile.locationAudits[0].id);
    }
    setScreen(s);
  };
  const navProps={
    screen,setScreen:navigate,
    hasAudit:orgProfile.hasAudit,hasPlan:orgProfile.hasPlan,
    onLogout:authApi.logout,
  };

  if(!["dashboard","waste-hub","waste-accounts",...AUDIT_FLOW_SCREENS].includes(screen)) return null;

  return (
    <Layout navProps={navProps}>
      {screen==="dashboard"&&<Dashboard orgProfile={orgProfile} waste={waste} setScreen={setScreen}/>}
      {screen==="waste-hub"&&<WasteDataHub waste={waste} accounts={accounts} org={orgProfile.org} setScreen={setScreen} setDataConfigOrigin={setDataConfigOrigin}/>}
      {screen==="waste-accounts"&&<WasteAccounts accounts={accounts} setScreen={setScreen}/>}
      {AUDIT_FLOW_SCREENS.includes(screen)&&(
        <AuditFlow
          screen={screen} setScreen={setScreen}
          orgProfile={orgProfile} waste={waste}
          dataConfigOrigin={dataConfigOrigin} setDataConfigOrigin={setDataConfigOrigin}
        />
      )}
    </Layout>
  );
}
